import React, { useState } from "react";
import PropTypes from "prop-types";
import AppUtils from "@src/utils/appUtils";
import CountUp from "react-countup";

const AnimateNumberCount = (props) => {
  const { total, durationMS = 2000 } = props;
  const [isAnimating, setIsAnimating] = useState(false);
  // regex matches number string with comma seperation and/or decimal places with optional prefix and suffix
  const totalString = total
    ? String(total).match(/^(\D*)(\d+(?:[\d\.\,]\d+)*?)(\D*)$/)
    : null;
  const prefix = totalString ? totalString[1] : "";
  const suffix = totalString ? totalString[3] : "";
  const endNumber = totalString ? totalString[2].replace(",", "") : total;
  const decimalsToShow = AppUtils.countDecimals(endNumber); // show same number or decimals as supplied

  return (
    <span className={isAnimating ? "will-change-contents" : ""}>
      <CountUp
        end={endNumber}
        duration={durationMS / 1000}
        decimals={decimalsToShow}
        prefix={prefix}
        suffix={suffix}
        onStart={() => setIsAnimating(true)}
        onEnd={() => setIsAnimating(false)}
      />
    </span>
  );
};

export const animateNumberCountControls = {
  total: {
    propType: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    description: "Target number to animate to (can be number or string)",
    controlType: "number",
    defaultValue: 100,
  },
  durationMS: {
    propType: PropTypes.number,
    description: "Animation duration in milliseconds",
    controlType: "number",
    min: 100,
    max: 5000,
    step: 100,
    defaultValue: 1000,
  },
};

AnimateNumberCount.propTypes = AppUtils.getPropTypeFromControls(
  animateNumberCountControls,
);

export default AnimateNumberCount;
